module.exports = __webpack_public_path__ + "img/mtTableY.a4d9805d.svg";